import PropTypes from 'prop-types';

const ChatAuthorName = function ChatAuthorName({
  translate,
  author,
  initials,
  crBlocked,
  gcatCode,
  grpNbr,
  fullWidth,
  prtnrLogoUrl,
}) {
  if (!author) return null;

  if (fullWidth) return null;

  const txt = `${author}${
    (gcatCode && ((gcatCode !== 'users') || (!initials)) && (grpNbr !== undefined))
      ? ` #${grpNbr}`
      : ''
  }`;

  return (
    <span className="flex flex-row gap-1 text-xs pl-8 w-full text-start text-txt-90">
      {(prtnrLogoUrl)
        ? <img alt="logoPartner" src={prtnrLogoUrl} className="h-4 w-4" />
        : null}
      {txt}
      {crBlocked
        ? (
            <span className="italic text-pxUiAlert ml-1 font-semibold">
              {translate('blocked')}
            </span>
          )
        : null}
    </span>
  );
};

ChatAuthorName.propTypes = {
  translate: PropTypes.func,
  author: PropTypes.string,
  initials: PropTypes.string,
  crBlocked: PropTypes.number,
  gcatCode: PropTypes.string,
  grpNbr: PropTypes.number,
  fullWidth: PropTypes.bool,
  prtnrLogoUrl: PropTypes.string,
};

export default ChatAuthorName;
